import generateUrlQuery from '../mixins/generate-url-query';
import getActivePage from '../mixins/get-active-page';

Vue.component('hb-pagination', {
  template: `
    <div class="pagination">
      <router-link class="pagination__page"
                   :to="generateUrlQuery({page: prevPage})"
      >
        &laquo;
      </router-link>

      <router-link class="pagination__page"
                   v-for="(page, i) of totalPages || 1"
                   :key="i"
                   :class="{'pagination__page--active': page === getActivePage}"
                   @click="onClick(page)"
                   :to="generateUrlQuery({page: page})"
      >{{ page }}
      </router-link>

      <router-link class="pagination__page"
                   :to="generateUrlQuery({page: nextPage})"
      >
        &raquo;
      </router-link>
    </div>
  `,
  mixins: [
    generateUrlQuery,
    getActivePage,
  ],
  props: ['totalPages'],
  computed: {
    prevPage() {
      return this.getActivePage > 1
        ? this.getActivePage - 1
        : this.getActivePage;
    },
    nextPage() {
      return this.getActivePage < this.totalPages
        ? this.getActivePage + 1
        : this.getActivePage;
    },
  }
});
